/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Travelcenter'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> ------------------------------------------------
    flightstatus_airportsOrigins: [],
    flightstatus_airportsDestinations: [],
    flightstatus_flightTracker: [],
    flightstatus_airportInfos: [],

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: Flightstatus
    ***************************************************************************/
    /***************************************************************************
    * get_Flightstatus_AirportOrigins()
    *
    * Desc:
    * Note:
    *
    */
    get_Flightstatus_AirportOrigins: state => {

        return state.flightstatus_airportsOrigins;

    }, // eo function get_Flightstatus_AirportOrigins()


    /***************************************************************************
    * get_Flightstatus_AirportDestinations()
    *
    * Desc:
    * Note:
    *
    */
    get_Flightstatus_AirportDestinations: state => {

        return state.flightstatus_airportsDestinations;

    }, // eo function get_Flightstatus_AirportDestinations()


    /***************************************************************************
    * get_Flightstatus_FlightTracker()
    *
    * Desc:
    * Note:
    *
    */
    get_Flightstatus_FlightTracker: state => {

        return state.flightstatus_flightTracker;

    }, // eo function get_Flightstatus_FlightTracker()


    /***************************************************************************
    * get_Flightstatus_AirportInfo()
    *
    * Desc:
    * Note:
    *
    */
    get_Flightstatus_AirportInfo: state => payload => {

        let website = null;


        state.flightstatus_airportInfos.forEach(airport => {
            if (airport.iataCode === payload) {
                website = airport.website;
            }
        });


        return website;

    }, // eo function get_Flightstatus_AirportInfo()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: Flightstatus Calls
    ***************************************************************************/
    /***************************************************************************
    * mut_call_listAirportsOrigines()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_listAirportsOrigines: (state, payload) => {

        const airportsToFilterOut = ['HER', 'KGS', 'RHO', 'CFU'],
            tmp_flightstatus_airportsOrigins = [];


        state.flightstatus_airportsOrigins = payload.originesRS.dep;
        state.flightstatus_airportsOrigins.sort((a, b) => (a.l > b.l) ? 1 : ((b.l > a.l) ? -1 : 0));

        // >>> Filter out ....
        state.flightstatus_airportsOrigins.forEach(apt => {
            if (airportsToFilterOut.includes(apt.i) === false) {
                tmp_flightstatus_airportsOrigins.push(apt);
            }
        });

        state.flightstatus_airportsOrigins = tmp_flightstatus_airportsOrigins;

    }, // eo function mut_call_listAirportsOrigines()


    /***************************************************************************
    * mut_call_listAirportsDestinations()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_listAirportsDestinations: (state, payload) => {

        const airportsToFilterOut = ['HER', 'KGS', 'RHO', 'CFU'],
            tmp_flightstatus_airportsDestination = [];


        state.flightstatus_airportsDestinations = payload.destinationsRS.des;
        state.flightstatus_airportsDestinations.sort((a, b) => (a.l > b.l) ? 1 : ((b.l > a.l) ? -1 : 0));

        // >>> Filter out ....
        state.flightstatus_airportsDestinations.forEach(apt => {
            if (airportsToFilterOut.includes(apt.i) === false) {
                tmp_flightstatus_airportsDestination.push(apt);
            }
        });

        state.flightstatus_airportsDestinations = tmp_flightstatus_airportsDestination;

    }, // eo function mut_call_listAirportsDestinations()


    /***************************************************************************
    * mut_call_listFlighttracker()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_listFlighttracker: (state, payload) => {

        state.flightstatus_flightTracker = payload;

    }, // eo function mut_call_listFlighttracker()


    /***************************************************************************
    * mut_call_listAirportInfos()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_listAirportInfos: (state, payload) => {

        state.flightstatus_airportInfos = payload;

    }, // eo function mut_call_listAirportInfos()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: Flightstatus Calls
    ***************************************************************************/
    /***************************************************************************
    * Call::'/registration/origines'
    *
    * Desc: Getting Airports - Origines ('listAirports').
    * Note:
    *
    */
    actn_call_listAirportsOrigines: (context, payload) => {

        var hdrs = '';


        // >>> Send Ajax Request ---------------------------------------
        Vue.prototype.$vp_m();
        axios.get('/registration/origines/')
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_listAirportsOrigines', response.data);
                        eventBus.$emit('callairportoriginessuccess');
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function call_listAirportsOrigines()


    /***************************************************************************
    * Call::'/registration/destinations'
    *
    * Desc: Getting Airports - Destinations ('listAirports').
    * Note:
    *
    */
    actn_call_listAirportsDestinations: (context, payload) => {

        var hdrs = '';


        // >>> Send Ajax Request ---------------------------------------
        Vue.prototype.$vp_m();
        axios.get('/registration/destinations/' + payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_listAirportsDestinations', response.data);
                        eventBus.$emit('callairportdestinationssuccess');
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_listAirportsDestinations()


    /***************************************************************************
    * Call::'/acm/forms/flighttracker'
    *
    * Desc: Getting Airports - Destinations ('listAirports').
    * Note:
    *
    */
    actn_call_listFlighttracker: (context, payload) => {

        var hdrs = '';


        // >>> Send Ajax Request ---------------------------------------
        Vue.prototype.$vp_m();
        axios.put('/acm/forms/flighttracker', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_listFlighttracker', response.data);
                        eventBus.$emit('callflighttrackersuccess');
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_listFlighttracker()



    /***************************************************************************
    * Call::'/acm/airport'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_listAirportInfos: (context, payload) => {

        var hdrs = '';


        // >>> Send Ajax Request ---------------------------------------
        axios.get('/acm/airport')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_listAirportInfos', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_listAirportInfos()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/flightstatus/flightstatus.js